/**
 * Names the rule that suppresses MLD's own patient result emails for an org,
 * or null when the org still sends them.
 *
 * Precedence: the explicit per-org toggle wins whenever it is a real boolean;
 * otherwise fall back to OHD mode, which has implied suppression since
 * 2026-05. Absent, malformed, or non-boolean values resolve to "send" —
 * failing open is deliberate, because a bad features value must never
 * silently swallow a patient's results notification.
 *
 * Shared so the Super Admin pill renders exactly the state the API will act
 * on; a second copy of this rule could drift and lie to the operator.
 */
export function patientEmailSuppressionReason(features) {
    if (typeof features?.send_mld_patient_emails === 'boolean') {
        return features.send_mld_patient_emails ? null : 'org_patient_email_toggle';
    }
    return features?.enable_employee_health_dashboard === true ? 'ohd_organization' : null;
}
/**
 * Decides whether MLD suppresses its own patient result emails for an org.
 * Same rule as patientEmailSuppressionReason, minus the "which rule" detail.
 */
export function shouldSuppressPatientEmails(features) {
    return patientEmailSuppressionReason(features) !== null;
}
